module.exports = __webpack_public_path__ + "img/file-check-01.4652d01c.svg";